<template>
  <SplitContainer21 ref="refSplitContainer21" style="height:100%" :layout="12">
    <template #top>
      <TableMain ref="vendPurchaseQuoteTable1" name="myName" :fields="fields" :title="table_title.title1"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
        :show_toolbar="true" :show_filter="true" :selectable="true" @on_query="on_query" :isBusy="isBusy_table1"
        :table_height_adjust="-8" :hb_table_class="'hb_table_vpq_search_class1'" :loading_width="60"
        @state_change="state_change" :show_toolbar_button="[0, 0, 1, 1, 1]" @tool_invoke="tool_invoke"
        @current_changed="current_changed" tableref="8106cfff96394632aed12f280593e736">
        <template #query>
          {{ $t("common.invent") + $t("common.num") }}：<el-input size="small" style="width: 150px" clearable
            v-model="ItemId" class="mr-1">
          </el-input>
          {{ $t("common.invent") + $t("common.name") }}：<el-input size="small" style="width: 200px" clearable
            v-model="NameAlias" class="mr-1">
          </el-input>
          {{ $t("common.provider") + $t("common.num") }}：<el-input size="small" style="width: 150px" clearable
            v-model="AccountNum"></el-input>
          {{ $t("common.provider") + $t("common.name") }}：<el-input size="small" style="width: 200px" clearable
            v-model="SEI_Name"></el-input>
          <!-- 显示已删除: <el-checkbox label="" v-model="is_deleted"></el-checkbox> -->
        </template>
      </TableMain>
    </template>
    <template #bottom>
      <TableMain ref="vendPurchaseQuoteTable3" :fields="item_fileds" :show_query_container="false"
        :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="-1"
        :show_filter="false" :show_pagination="show_pagination" :pager_count="5"
        :hb_table_class="'hb_table_vpq_search_class2'" @state_change="table3_state_change" :show_toolbar="false"
        @on_change="table3_on_change" @on_input="table3_on_change" tableref="ae11fdeab7ea401ca38dd42c0e3faf9d">
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveData"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </template>
  </SplitContainer21>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
import TableDetail from "../components/table/TableDetail"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import SplitContainer21 from "../components/container/SplitContainer21"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import * as VendPurchaseQuoteOutController from "../../controllers/sd/VendPurchaseQuoteOutController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as commonController from '../../controllers/commonController'
import Vue from "vue"

export default {
  name: "VendPurchaseQuoteSearch",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer21,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_vend_purch_price_internal",
        title2: "table_invent",
        title3: "table_vend_price_edit_internal",
      },
      fields: VendPurchaseQuoteOutController.fields.default_internal,
      invent_fields: VendPurchaseQuoteOutController.fields.invent_fields,
      item_fileds: _.cloneDeep(
        VendPurchaseQuoteOutController.fields.item_fileds_internal
      ),
      dataForm: _.cloneDeep(VendPurchaseQuoteOutController.dataForm),
      show_pagination: false,
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      AccountNum: "",
      ItemId: "",
      SEI_Name: "",
      NameAlias: "",
      vender_options: [],
      vender_search_options: [],
      invent_retail_options: [],
      venders: [],
      all_purchase: [],
      all_role_users: [],
      all_role_list: [],
      is_deleted: false,
    }
  },
  activated() { },
  deactivated() { },
  computed: {},
  async created() {
    let _this = this
    let _field1 = _.find(_this.item_fileds, {
      key: "RetailVariantId",
    })
    _field1["_options"] = {
      base_on_field: "ItemId",
      provider: (v) => {
        return _.map(_this.setInventData(v), (t) => {
          return {
            value: t.RetailVariantId,
            label: t.RetailVariantId + "：" + t.VariantName,
          } //VariantName
        })
      },
    }
    let _fields = _.find(_this.item_fileds, { key: "CurrencyCode" })
    _.remove(_fields, (n) => {
      return n == "id"
    })
    _fields["_options"] = {
      provider: (v) => {
        return _.map(_this.$store.state.biz_data.baseData.Currency, (v) => {
          return {
            value: v.CurrencyCode,
            label: v.CurrencyCode + ": " + v.Txt,
          }
        })
      },
    }
    let _field3 = _.find(this.item_fileds, {
      key: "TaxGroup",
    })
    _field3["_options"] = {
      base_on_field: "AccountNum",
      provider: (v) => {
        let list = _.map(_this.$store.state.biz_data.baseData.TaxGroupHeading, (t) => {
          return {
            value: t.TaxGroup,
            label: t.TaxGroup + ":" + t.TaxGroupName,
          }
        })
        // let list = _.map(_.filter(_this.$store.state.biz_data.baseData.AllVender, { AccountNum: v }), (t) => {
        //   let m = _.find(_this.$store.state.biz_data.baseData.TaxGroupHeading, { TaxGroup: t.TaxGroup })
        //   if (m) {
        //     return {
        //       value: m.TaxGroup,
        //       label: m.TaxGroup + ":" + m.TaxGroupName,
        //     };
        //   }
        // });
        return _.uniqBy(list, "value")
      },
    }
    await this.getAllRoles()
    await this.getAllRoleUsers()
  },
  mounted() {
    this.$refs.refSplitContainer21.split_setting2 = 0.7
    this.getOptions()
  },
  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    ///获取物料相关信息
    async getInventData(_itemId) {
      if (_.isNull(_itemId)) {
        return
      }
      let _result = await InventTableController.methods.getItemData({
        // ItemId: { "=": _itemId }
        ItemId: _itemId,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let _list = _.filter(_result[0], (t) => {
          return t.RetailVariantId != ""
        })

        let _p = {
          ItemId: _itemId,
          options: _list,
        }
        this.invent_retail_options = []
        this.invent_retail_options.push(_p)
        // let _index = _.findIndex(this.invent_retail_options, (t) => {
        //   return t.ItemId == _p.ItemId;
        // });
        // if (_index < 0) {
        //   this.invent_retail_options.push(_p);
        // }
      }
    },
    ///变形编号
    setInventData(_itemId) {
      let _m = _.find(this.invent_retail_options, { ItemId: _itemId })
      if (_m) {
        return _m.options
      }
      return []
    },
    //预加载部分options
    getOptions() {
      this.vender_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.baseData.Vender,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 300)
      this.vender_search_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.baseData.Vender,
          ["modifiedDateTime"],
          ["desc"]
        )
      ).splice(0, 300)
    },

    //#region Table1
    ///查询
    async on_query(set_data, date_range) {
      let has_privilige = commonController.methods.checkPrivilige(this, "z-InternalVendQuote", "内部供应商报价操作权限")
      if (!has_privilige) {
        set_data([])
        return
      }
      this.isBusy_table1 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {
        SEI_Name: { like: "%" + this.SEI_Name + "%", "<>": "" },
        NameAlias: { like: "%" + this.NameAlias + "%", "<>": "" },
        is_deleted: { "=": 0 },
      }

      if (this.ItemId != "") {
        _params.ItemId = { like: "%" + this.ItemId + "%" }
      }
      if (this.AccountNum != "") {
        _params.AccountNum = { like: "%" + this.AccountNum + "%" }
      }
      if (this.is_deleted) {
        delete _params.is_deleted
      }
      if (!_.isNull(date_range) && this.ItemId == "" && this.SEI_Name == "" && this.AccountNum == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["create_at"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      this.all_purchase = []
      let _result = await VendPurchaseQuoteOutController.methods.getData(
        _params, "VendInternalQuote"
      )

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.isBusy_table1 = false
        if (_result[0].Result) {
          let vender_list = []
          let companyInfoList = _.map(this.$store.state.biz_data.baseData.CompanyInfo, "VenderAccountNum")
          _.each(_result[0].Result.Data[0], (t) => {
            if (_.includes(companyInfoList, t.AccountNum)) {
              vender_list.push(t)
            }
            this.getApprover(t)
          })
          set_data(_.orderBy(vender_list, ["id"], ["desc"]))
          this.all_purchase = _.orderBy(
            vender_list,
            ["id"],
            ["desc"]
          )
        }
      }
      this.isBusy_table1 = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        "fcGetDocumentApprover",
        "VQApprover",
        t.fcCheckDocumentApproved
      )

    },
    ///状态切换
    async state_change(data, cb) {
      if (data && data.state === "deleted") {
        if (data.selected_items.length > 0) {
          let _check_del_list = []
          _.each(data.selected_items, function (t) {
            if (t.fcCheckDocumentApproved) {
              _check_del_list.push(t.id)
            }
          })
          if (_check_del_list.length > 0) {
            this.msgToasts(this.$t("common.num") + "：" + _.join(_check_del_list, "，") + "，" + this.$t("notify.has_approved"))
            cb(false)
            return
          }
          this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
            if (v) {
              let result =
                await VendPurchaseQuoteOutController.methods.deleteData(
                  data.selected_items
                )
              if (result) {
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
                cb(false)
              }
            }
          })
        }
      } else if (data.state === "approved" || data.state === "unapproved") {
        let _msg = data.state == "approved" ? this.$t("common.approved") : this.$t("common.unapproved")
        ///检查是否已经审批或反审
        let _state = data.state == "approved" ? true : false
        if (this.checkIsApproved(data.selected_items, "fcCheckDocumentApproved", _state)) {
          this.msgToasts(this.$t("notify.has_approved_or_unapproved"))
          cb(false)
          return
        }
        ///检查是否有该权限
        let check_pro = await this.checkApproveStatus(data.selected_items)
        if (!check_pro.is_ok) {
          let id_str = _.map(check_pro.check_list, (t) => {
            return t.id
          })
          id_str.reverse()
          this.msgToasts(this.$t("notify.not_privileges") + "（" + _.join(id_str, "，") + "）！", "error")
          cb(false)
          return
        }
        ///执行审批
        {
          if (!await this.msgModal(this.$t("notify.is_continue"))) {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'VendPurchaseQouteSearch', data, this)
            cb(false)
            return
          }
          let _list = data.selected_items
          _.each(_list, (t) => {
            t.is_approved = data.state == "approved" ? true : false
            t.local_username = this.$global.global_data.local_username
            let at = _.find(check_pro.check_list, { id: t.id })
            if (at && at.approve_status && at.approve_status[0]) {
              t.status_id = at.approve_status[0].id
            }
          })
          let result = await VendPurchaseQuoteOutController.methods.approveData(_list)
          if (result) {
            _.each(data.selected_items, (t) => {
              t.fcCheckDocumentApproved = data.state == "approved" ? true : false
              if (_list && data.state != "approved") {
                let at = _.find(check_pro.check_list, { id: t.id })
                if (at && at.approve_status && at.approve_status.length > 0) {
                  let at_m = at.approve_status[0]
                  let _approver = ""
                  if (at_m.isRole) {
                    let role_name_list = _.map(this.all_role_users, (t) => {
                      if (t.role_code == at_m.Approver) {
                        return t.username
                      }
                    })
                    _approver = role_name_list.join("，")
                  }
                  else {
                    _approver = at_m.Approver
                  }
                  t.VQApprover = _approver
                }
              } else {
                t.VQApprover = ""
              }
            })
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'VendPurchaseQouteSearch', data, this)
            cb(true)
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
        }
      }
    },
    ///检查是否包含该审批权限
    async checkApproveStatus(data) {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let is_all_ok = true
      for (var i in data) {
        let t = data[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "VendInternalQuote",
          ApproveType: "",
          ItemId: t.id,
        })
        for (var j in _as_result[0]) {
          let at = _as_result[0][j]
          if (at) {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
            }
            else {
              is_all_ok = false
            }
          }
        }
        if (_.findIndex(_check_list, { id: t.id }) < 0) {
          t.approve_status = _as_result[0]
          _check_list.push(t)
        }
      }
      return { is_ok: is_all_ok, check_list: _check_list }
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (t[code] == state) {
          return t
        }
      })
      return _index > -1
    },
    ///print
    tool_invoke() { },
    ///row click
    async current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.vendPurchaseQuoteTable3.SetData([])
        return
      }
      this.isBusy_table3 = true
      await this.getInventData(current.ItemId) //查询变形编号
      let _current = _.find(this.all_purchase, { id: current.id })

      let _m = _.cloneDeep(this.dataForm)
      for (var i in _m) {
        _m[i] = _current[i]
      }
      let _list = []
      _list.push(_m)
      this.$refs.vendPurchaseQuoteTable3.SetData(_list)

      this.table_title.title3 = "table_edite_price"
      this.venders = []
      this.isBusy_table3 = false
    },
    //#endregion

    //#region Table2
    ///查询物料
    async invent_query(set_data, date_range) {
      this.isBusy_table2 = true
      let _fromDate = "",
        _toDate = ""
      let _params = {
        NameAlias: { like: "%" + this.NameAlias + "%" },
      }
      if (!_.isNull(date_range) && this.NameAlias == "") {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["modifiedDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }
      set_data([])
      let _result = await InventTableController.methods.getData(_params)

      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
      }
      this.isBusy_table2 = false
    },

    //#endregion

    //#region Table3

    Calc_Cost_Sum(data) {
      let sum = 0
      if (data.EXP != "") {
        sum += data.EXP
      }
      if (data.M11 != "") {
        sum += data.M11
      }
      if (data.M12 != "") {
        sum += data.M12
      }
      if (data.M22 != "") {
        sum += data.M22
      }
      if (data.M23 != "") {
        sum += data.M23
      }
      if (data.M24CTP != "") {
        sum += data.M24CTP
      }
      if (data.M25 != "") {
        sum += data.M25
      }
      if (data.M26 != "") {
        sum += data.M26
      }
      if (data.O11 != "") {
        sum += data.O11
      }
      if (data.O12 != "") {
        sum += data.O12
      }
      if (data.O23 != "") {
        sum += data.O23
      }
      if (data.O24 != "") {
        sum += data.O24
      }
      if (data.O25 != "") {
        sum += data.O25
      }
      if (data.O26 != "") {
        sum += data.O26
      }
      if (data.S11 != "") {
        sum += data.S11
      }
      if (data.X != "") {
        sum += data.X
      }
      if (data.Y != "") {
        sum += data.Y
      }
      if (data.Z != "") {
        sum += data.Z
      }
      if (sum != 0) {
        data.Cost_Sum = sum
      }
    },
    ///保存
    async saveData(cb) {
      let _this = this
      let _list = _.cloneDeep(this.$refs.vendPurchaseQuoteTable3.my_data)
      if (_list.length > 0) {
        let _is_check_ok = await this.ValidData()
        if (_is_check_ok == false) {
          cb(false)
          return
        }

        let _items = []
        _.each(_list, (t) => {
          let _data = _.cloneDeep(t)
          delete _data._current
          delete _data._id
          delete _data._selected
          let _m = _.find(_this.$store.state.biz_data.baseData.Vender, {
            AccountNum: _data.AccountNum,
          })
          if (_m) {
            _data.SEI_Name = _m.SEI_Name
          }

          ///变形名称
          let _mr = _.find(this.invent_retail_options, {
            ItemId: _data.ItemId,
          })

          if (_mr) {
            let _t = _.find(_mr.options, {
              RetailVariantId: _data.RetailVariantId,
            })
            if (_t) {
              _data.VariantName = _t.VariantName
            }
          }

          if (_.isDate(_data.FromDate)) {
            _data.FromDate = _this.$date.format(_data.FromDate, "yyyy-MM-dd")
          }
          if (_.isDate(_data.ToDate)) {
            _data.ToDate = _this.$date.format(_data.ToDate, "yyyy-MM-dd")
          }
          //计算cost_sum
          this.Calc_Cost_Sum(_data)
          _data.create_by_username = this.$global.global_data.local_username
          _items.push(_data)
        })
        ///保存数据
        let _rel_save_data = await VendPurchaseQuoteOutController.methods.saveData(_items, "VendInternalQuote")
        cb(true)
        if (!_.isNull(_rel_save_data)) {
          ///成功
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          let _dt = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/i/") > -1
          })

          //新增
          let _rel_items = []
          if (_dt && _dt.length > 0) {
            _.each(_dt, (t) => {
              _rel_items = _.union(_rel_items, t.Result.Data[0])
            })
            this.$refs.vendPurchaseQuoteTable1.InsertItems(
              _.orderBy(_rel_items, ["id"], ["desc"])
            )

            this.$refs.vendPurchaseQuoteTable3.SetData([])
            this.dataForm = _.cloneDeep(
              VendPurchaseQuoteOutController.dataForm
            )
          }

          //修改
          let _update_list = _.filter(_rel_save_data, function (t) {
            return t.Code.indexOf("data/u/") > -1
          })
          if (_update_list && _update_list.length > 0) {
            _.each(_update_list, (t) => {
              let _ul = t.Result.Data[0]
              _.each(_ul, (m) => {
                this.$refs.vendPurchaseQuoteTable1.UpdateItems({ id: m.id }, m)
                this.$refs.vendPurchaseQuoteTable3.UpdateItems({ id: m.id }, m)

                let this_ = this
                let items = _.filter(this_.all_purchase, { id: m.id })
                _.each(items, (d) => {
                  _.each(m, (v, k) => {
                    Vue.set(d, k, v)
                  })
                })
              })
            })
          }
          this.venders = []
        } else {
          ///失败
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      } else {
        cb(true)
      }
    },
    ///保存前检查
    async ValidData() {
      ///检查是否审核
      let _check_approved = true
      let _master_m = this.$refs.vendPurchaseQuoteTable1.GetCurrentItem()
      if (_master_m && !_.isNull(_master_m)) {
        if (_.isInteger(_master_m.id) && _master_m.fcCheckDocumentApproved) {
          _check_approved = false
        }
      }
      if (!_check_approved) {
        this.msgToasts("已审核数据不能被修改！", "error")
        return false
      }
      ///检查数量
      let _list = _.cloneDeep(this.$refs.vendPurchaseQuoteTable3.my_data)
      let _index = _.findIndex(_list, function (t) {
        if (t.QuantityAmountFrom == 0 && t.QuantityAmountTo == 0) {
          return t
        }
      })
      // if (_index > -1) {
      //   this.msgToasts("开始数量和结束数量不能同时为0或空！", "info");
      //   return false;
      // }
      _index = _.findIndex(_list, function (t) {
        if (!_.isNull(t.QuantityAmountFrom) && !_.isNull(t.QuantityAmountTo)) {
          if (t.QuantityAmountFrom > t.QuantityAmountTo) {
            return t
          }
        }
      })
      if (_index > -1) {
        this.msgToasts(this.$t("notify.vend_price_start_must_can_not_lg_end"), "info")
        return false
      }

      ///检查价格
      let _price_list = _.cloneDeep(this.$refs.vendPurchaseQuoteTable3.my_data)
      let _price_index = _.findIndex(_price_list, function (t) {
        if (isNaN(t.Amount) || _.isNull(t.Amount)) {
          return t
        }
      })
      if (_price_index > -1) {
        this.msgToasts("请输入价格！", "info")
        return false
      }
      return true
    },
    ///del item
    table3_state_change(data, cb) {
      if (data.state == "deleted") {
        if (
          data.selected_items.length == 1 &&
          _.isInteger(data.selected_items[0].id)
        ) {
          this.msgToasts(this.$t("notify.not_supply"), "info")
        } else {
          this.$refs.vendPurchaseQuoteTable3.RemoveItems(data.selected_items)
        }
      }
    },
    table3_on_change: _.debounce(
      async function (data) {

        let _this = this
        if (data.field.key == "Amount" || data.field.key == "TaxGroup" || data.field.key == "CurrencyCode") {
          if (data.item.Amount && data.item.Amount != "") {
            ///获取含税价格和非含税价格
            let _price_tax = {
              currency: data.item.CurrencyCode,
              amount: data.item.Amount,
              incTax: 1,
              taxGroup: data.item.TaxGroup
            }
            let _cnyAmount_m =
              await SalesOrderController.methods.getLocalAmountWOTaxData(
                _price_tax
              )
            if (!_.isNull(_cnyAmount_m) && _cnyAmount_m[0]) {
              if (!_.isNull(_cnyAmount_m[0][0].CNYAmount)) {
                data.item.AmountWOTax = _cnyAmount_m[0][0].CNYAmount
              }
              if (!_.isNull(_cnyAmount_m[0][0].CNYAmountWOTax)) {
                data.item.AmountWOTax = _cnyAmount_m[0][0].CNYAmountWOTax
              }
            }
          }
        }
      },
      200,
      { leading: false, trailing: true }
    ),
    //#endregion
  },
}
</script>
<style>
.hb_table_vpq_search_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 220rem;
}

.hb_table_vpq_search_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 280rem;
}
</style>
<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
